import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";

const StyledTabs = styled(Tabs)(({ theme }) => ({
  "& .MuiTabs-indicator": {
    display: "none", // Hide the default indicator
  },
}));
const StyledTab = styled(Tab)(({ theme, active }) => ({
  backgroundColor: active ? "#D4ECDE" : "transparent",
  color: active
    ? theme.palette.primary.contrastText
    : theme.palette.text.primary,
  borderRadius: theme.shape.borderRadius,
  padding: "8px 16px", // Adjust padding as needed
  textTransform: "none", // Prevent uppercase transformation
  transition: "background-color 0.1s",
}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

export default function BasicTabs({ tabs }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <StyledTabs
        value={value}
        onChange={handleChange}
        variant="fullWidth"
        scrollButtons={false}
        aria-label="custom tabs example"
      >
        {tabs.map(({ label }, i) => (
          <StyledTab
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Box
                  sx={{
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                >
                  {label}
                </Box>
              </Box>
            }
            key={i}
            active={value === i}
          />
        ))}
      </StyledTabs>

      {tabs.map(({ component }, i) => (
        <TabPanel value={value} index={i} key={i}>
          {component}
        </TabPanel>
      ))}
    </>
  );
}
